export { default } from './Inline';
